<template>
  <v-list class="add-box-viewer-list" flat>
    <v-list-item-group
      v-for="(member, index) in GET_MGR_USER_LIST"
      :key="index"
    >
      <v-list-item class="px-0" v-if="member.name" :ripple="false">
        <!-- 담당자 정보 -->
        <v-list-item-content>
          <v-list-item-title
            ><span class="name" v-text="member.name"></span
            ><span class="sub-desc ml-2" v-text="member.mgrJikchakNm"></span
            ><span class="sub-desc divider" v-text="member.mgrOrgNm"></span
          ></v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-chip
            v-if="GET_APPL_SEQ_EXIST == 'Y' && member.agreeStatusCd != null"
            class="status"
            :class="statusChipClass(member.agreeStatusCd)"
          >
            {{ member.agreeStatusCdNm }}

            <v-icon size="16">
              {{
                member.agreeStatusCd == 30
                  ? 'mdi-close'
                  : member.agreeStatusCd == 20
                  ? 'mdi-check'
                  : ''
              }}
            </v-icon>
          </v-chip>
        </v-list-item-icon>
      </v-list-item>

      <!-- 의견 -->
      <v-list-item
        v-if="member.memo != null && member.memo != ''"
        class="opinion-outer"
      >
        <v-list-item-content class="pt-0 pb-5 pr-5">
          <v-sheet class="opinion-wrap" color="lightGrey">
            <v-list-item-subtitle class="opinion-title"
              >의견</v-list-item-subtitle
            >
            <div class="opinion-desc">{{ member.memo }}</div>
          </v-sheet>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-show="GET_MGR_USER_LIST.length - 1 > index"></v-divider>
    </v-list-item-group>
  </v-list>
</template>

<script>
/* 참조자 리스트 */
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_MGR_USER_LIST', 'GET_APPL_SEQ_EXIST']),

    statusChipClass() {
      return agreeStatusCd => {
        return {
          // 결재상태코드(10:결재요청, 20:결재완료, 30:반려)
          accept: agreeStatusCd == 20,
          reject: agreeStatusCd == 30,
        };
      };
    },
  },
};
</script>

<style></style>
